import { faFlask } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link, Typography } from '@material-ui/core'
import React, { useCallback, useState } from 'react'
import styled from 'styled-components'

import { useTestKitProducts } from '../../../lib/products/hooks/useTestKitProducts'
import PolicyModal from './PolicyModal'

const ItemPolicyMessage: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Typography variant="caption" paragraph>
    {children}
  </Typography>
)

const StyledItemPolicyMessage = styled(ItemPolicyMessage)`
  // increase specificity
  && {
    display: block;
    padding-right: 15px;
  }
`

export interface TestKitPolicyMessageProps {
  sku: string
}

const TestKitPolicyMessage: React.FC<TestKitPolicyMessageProps> = ({ sku }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const toggleModal = useCallback(() => {
    setIsModalOpen((prevState) => !prevState)
  }, [])

  const { isTestKitSku } = useTestKitProducts()
  const isTestKit = isTestKitSku(sku)

  if (!isTestKit) {
    return null
  }

  return (
    <>
      <StyledItemPolicyMessage>
        <FontAwesomeIcon icon={faFlask} /> For expiration details,{' '}
        <Link onClick={toggleModal}>click here.</Link>
      </StyledItemPolicyMessage>
      <PolicyModal isOpen={isModalOpen} toggleModal={toggleModal}>
        Some test kits contain materials which, if not utilized within one year, lose efficacy. We
        require that you submit your test kit for processing within one year of purchase date.
      </PolicyModal>
    </>
  )
}

export default TestKitPolicyMessage
